// Household tablet codes: GetScreen builds them from the default Home templates. "-simple" is the
// household's "prayer times only" choice, "-next" its "next prayer" one. "home-s42" is the masjid's own
// screen 42, one it ticked for homes and the household chose.
export const isHomeCode = (code?: string | null): boolean =>
  /^home((-portrait)?(-simple|-next)?|-s\d+)$/i.test(code ?? "");

export const isMasjidScreenCode = (code?: string | null): boolean => /^home-s\d+$/i.test(code ?? "");
